import { addDays, addMonths, addWeeks, format, startOfMonth, startOfWeek } from 'date-fns'
import { es } from 'date-fns/locale'

import { BillingPeriod } from '@/components/ReservationContext'

export const getPeriodLabel = (selectedDate: Date, selectedPeriod: BillingPeriod): string => {
    switch (selectedPeriod) {
        case 'daily': {
            const endDaily = selectedDate
            const startDaily = addDays(endDaily, -11)
            return `Del ${format(startDaily, 'dd MMM', { locale: es })} al ${format(endDaily, 'dd MMM', { locale: es })}`
        }
        case 'weekly': {
            const endWeekly = startOfWeek(selectedDate, { locale: es })
            const startWeekly = addWeeks(endWeekly, -11)
            return `Del ${format(startWeekly, 'dd MMM', { locale: es })} al ${format(endWeekly, 'dd MMM', { locale: es })}`
        }
        case 'monthly': {
            const endMonthly = startOfMonth(selectedDate)
            const startMonthly = addMonths(endMonthly, -11)
            return `De ${format(startMonthly, 'MMMM yyyy', { locale: es })} a ${format(endMonthly, 'MMMM yyyy', { locale: es })}`
        }
        default:
            return ''
    }
}
